import React, { useState } from 'react';
import { WithAccessControl } from '@meesho/pbac-core/client';
import DashBoardNavigation from '../dashboard/dashboardnavigation/DashBoardNavigation';
import withRouter from '../../withRouter';
import { useLocation, useParams } from 'react-router-dom';
import { resourcesRegistry } from '@pbac-registry/resources-registry';
import { useFeatures } from '../../contexts/FeaturesContext';

const notRequiredSidebarRoutes = [
  '/login',
  '/signup',
];

const AppContainer = (props) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();
  const params = useParams();
  const { isFeaturesLoading, clearUser } = useFeatures();

  const isNotRequiredSidebarRoute = notRequiredSidebarRoutes.includes(location.pathname);
  const toggleSideBar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const getPageResource = (resource) => {
    console.log('getPageResource location.pathname', props?.path, params);
    const task = window?.location?.pathname?.split('/')?.[2];

    if (props?.path === '/ads-task/:task/add') {
      return resourcesRegistry.pageAdsTaskAddByTask(task);
    }
    if (props.path === '/ads-task/:task/:id/status') {
      return resourcesRegistry.pageAdsTaskIdStatusByTask(task);
    }
    if (props.path === '/ads-task/:task') {
      return resourcesRegistry.pageAdsTaskByTask(task);
    }

    if (props.path === '/dynamic-webview/editor/:pageId') {
      const pageId = params.pageId;
      return pageId === '0' ? resourcesRegistry.pageDynamicWebviewAdd : resourcesRegistry.pageDynamicWebviewEditorId;
    }
    return resource;
  };
  return (
    <div id="wrapper" className={' ' + (sidebarOpen ? '' : ' sidebarClosed')}>
      {!isNotRequiredSidebarRoute && <DashBoardNavigation
        user={props.user}
        user_roles={props.user?.roles || []}
        toggleSideBar={() => toggleSideBar()}
        isFeaturesLoading={isFeaturesLoading}
        clearUser={clearUser}
        {...props}
      />}
      {props?.resource && props?.action ? (
        <div id='page-wrapper'>
          <WithAccessControl
            resource={getPageResource(props.resource)}
            action={props.action}
            attachedPolicies={props.attachedPolicies}
          >
            {React.cloneElement(props.children, { ...props })}
          </WithAccessControl>
        </div>

      ) : (
        <div id={props.path !== '/login' ? 'mt-16' : ''}>
          {React.cloneElement(props.children, { ...props })}
        </div>
      )}
    </div>
  );
};

export default withRouter(AppContainer);
